import { Comment } from '@/core/models/comment.model';

export interface CommentState {
  comments: Comment[];
  loading: boolean;
  error: any | null;
  submitting: boolean;
  submitError: any | null;
}

export const initialCommentState: CommentState = {
  comments: [],
  loading: false,
  error: null,
  submitting: false,
  submitError: null,
};
